import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import { NavLink, useHistory, useLocation, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import DayPicker from 'react-day-picker';
import { parse, stringify } from 'qs';
import moment from 'moment';
import DATE_FORMAT from '../components/constants/dateFormat';
import utils from '../utils/utils';
import { matchPath } from 'react-router';

const RoutePlannerSidebar = ({ match, location, history }) => {
  const [openXs, setOpenXs] = useState(false);

  const matchWithCategoryParams = matchPath(location.pathname, {
    path: `${match.path}/date/:date?`,
  });

  const sidebarClasses = classNames({
    'route-planner-sidebar': true,
    'm-open-xs': openXs,
  });

  const selectDate = (date) => {
    history.replace({
      pathname: `/routePlanner/date/${moment(date).format(DATE_FORMAT.url)}`,
    });
  };

  const urlDate =
    matchWithCategoryParams && matchWithCategoryParams.params.date
      ? utils.getDateFromString(matchWithCategoryParams.params.date, DATE_FORMAT.url)
      : null;
  const selectedDay = urlDate?.toDate();

  return (
    <div className={sidebarClasses}>
      <div className="route-planner-sidebar__top m-b-3">
        <div className="route-planner-sidebar__top-toggle" onClick={() => setOpenXs(!openXs)}>
          {openXs ? <FontAwesomeIcon icon={faAngleUp} /> : <FontAwesomeIcon icon={faAngleDown} />}
        </div>
      </div>

      <ul className="list-unstyled m-b-6">
        <li className="m-b-2">
          🗓{' '}
          <NavLink exact to={`${match.url}`} className="link">
            <FormattedMessage id={'route.planner.sidebar.links.route.plans'} />
          </NavLink>
        </li>
        <li className="m-b-2">
          🚙{' '}
          <NavLink exact to={`/routePlanner/drivers`} className="link">
            <FormattedMessage id={'route.planner.sidebar.links.drivers'} />
          </NavLink>
        </li>
        <li className="m-b-2">
          🏠{' '}
          <NavLink exact to={`/routePlanner/startDepots`} className="link">
            <FormattedMessage id={'route.planner.sidebar.links.start.depots'} />
          </NavLink>
        </li>
      </ul>

      <div className="route-planner-sidebar__calendar">
        <DayPicker mode="single" selectedDays={[selectedDay]} onDayClick={selectDate} />
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

function useUrlParameterState(param) {
  const { search } = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(search), [search]);
  const id = queryParams.get(param);

  const history = useHistory();
  const searchObj = parse(search, { ignoreQueryPrefix: true });

  const setNewValue = (newId, resetOtherQueryParams) => {
    searchObj[param] = newId;
    const newObj = resetOtherQueryParams ? { [param]: newId } : searchObj;
    history.replace({
      search: stringify(newObj, { ignoreQueryPrefix: false }),
    });
  };

  return [id, setNewValue];
}

export default withRouter(connect(mapStateToProps)(RoutePlannerSidebar));
